import React from "react";
import "./styles.css";
import { IoGlobeOutline } from "react-icons/io5";

export const HomeCategorySection = ({
  mainTitle,
  type,
  icon,
  background,
  dataListing,
  handleTranslate,
  onAddButtonClicked,
  onTranslateButtonClicked,
  onShareButtonClicked,
}) => {
  return (
    <div className="itemContainer">
      <div className={"itemHeader"}>
        <div className="iconContainer">
          <div
            className="iconInnerContainer"
            style={{ backgroundColor: background }}
          >
            <img src={icon} alt="" />
          </div>
        </div>
        <div className="titleContainer">
          <span className="mainTitleStyling">{mainTitle}</span>
          <span className="countValueStyling">
            {dataListing && dataListing.length
              ? `${dataListing.length} Item(s)`
              : `No ${mainTitle} Added`}
          </span>
        </div>
      </div>

      <div
        style={{
          padding: "20px",
          transition: "opacity 0.6s ease-in-out",
          borderBottom: "2px solid",
          borderLeft: "2px solid",
          borderRight: "2px solid",
          borderColor: "#EFF3FC",
          borderBottomLeftRadius: 15,
        }}
      >
        <div style={{ flexDirection: "column", display: "flex" }}>
          {type !== "documents" ? (
            dataListing && dataListing.length > 0 ? (
              <>
                {dataListing.map((item) => (
                  <div className="addedItemContainer">
                    <span className="addItemTitle">{`${item.description}`}</span>
                  </div>
                ))}
                <div
                  className="buttonStyling"
                  type="button"
                  onClick={handleTranslate}
                >
                  <IoGlobeOutline size={20} />
                  <span>TRANSLATE</span>
                </div>
              </>
            ) : (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <span>{`No ${mainTitle} Found`}</span>
              </div>
            )
          ) : (
            <>
              {dataListing && dataListing.length > 0 ? (
                dataListing.map((item) => {
                  const { category, title, description, url } = item;
                  return (
                    <a
                      className="addedDocumentContainer"
                      href={url}
                      target="_blank"
                    >
                      <div className="addedDocumentTextContainer">
                        <span
                          style={{
                            fontSize: "10px",
                            fontWeight: "bolder",
                            color: "#47B6F6",
                          }}
                        >
                          {category}
                        </span>
                        <span style={{ color: "black" }}>{title}</span>
                        <span style={{ color: "grey" }}>{description}</span>
                      </div>
                    </a>
                  );
                })
              ) : (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <span>{`No ${mainTitle} Found`}</span>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};
